let modals = require( './modals' );

let event_single_add_to_basket = function( $ ) {

	let $title_bar,
		$modal,
		anim_speed = 400,
		notice_show_time = 5000 + anim_speed,
		form_ids = [
			'#standard-add-to-cart',
			'#manager-standard-add-to-cart',
			'#red-whale-add-to-cart',
			'#manager-red-whale-add-to-cart'
		];

	let _init = function() {
		$title_bar = $( '#title-bar.event-title-bar' );

		if ( $title_bar.length > 0 ) {
			$modal = $( '#added-tickets-modal' );

			_setup_form_responses();

			_setup_bottom_toggles();
		}
	};

	let _setup_bottom_toggles = function() {
		$title_bar.find( '.toggle-bottom, .open-bottom, .close-bottom' ).on( 'click', ( e ) => {
			e.preventDefault();

			_toggle_bottom();
		} );
	};

	let _toggle_bottom = function() {
		if ( $title_bar.hasClass( 'animating' ) ) {
			return;
		}

		$title_bar.addClass( 'animating' );

		if ( $title_bar.hasClass( 'bottom-open' ) ) {
			_close_bottom();
		} else {
			_open_bottom();
		}

		setTimeout( () => {
			$title_bar.removeClass( 'animating' );
		}, anim_speed );
	};

	let _open_bottom = function() {
		$title_bar.find( '.bottom' ).slideDown( anim_speed );
		$title_bar.addClass( 'bottom-open' );
		$title_bar.removeClass( 'bottom-closed' );
	};

	let _close_bottom = function() {
		$title_bar.find( '.bottom' ).slideUp( anim_speed );
		$title_bar.addClass( 'bottom-closed' );
		$title_bar.removeClass( 'bottom-open' );
	};

	let _setup_form_responses = function() {
		form_ids.forEach( ( value, index ) => {
			$( value ).on( 'saved', _form_response );
		} );
	};

	let _form_response = function( e, response ) {
		if ( response.add_to_cart_errors ) {
			_show_notices( response.add_to_cart_errors );
		}

		if ( response.add_to_cart_count ) {
			modals.close_all_modals();
			_show_ticket_popup( response.add_to_cart_count );
		}
	};

	let _show_ticket_popup = function( count ) {
		let tickets_ticket  = count > 1 ? 'tickets' : 'ticket',
			have_has = count > 1 ? 'have' : 'has';

		$modal.find( '.text .ticket-count' ).text( count );
		$modal.find( '.text .tickets-ticket' ).text( tickets_ticket );
		$modal.find( '.text .have-has' ).text( have_has );

		// Give text time to change
		setTimeout( () => {
			modals.open_modal( $modal );
		}, 50 )
	};

	let _show_notices = function( notices, scroll_to = true ) {
		if ( $title_bar.find( '.notices .notice' ).length > 0 ) {
			clear_notices();

			// Give time for notices to clear
			setTimeout( () => {
				$.each( notices, ( index, item ) => {
					_show_notice( index, item, 'error', notice_show_time );
				} );
			}, anim_speed );
		} else {
			$.each( notices, ( index, item ) => {
				_show_notice( index, item, 'error', notice_show_time );
			} );
		}

		if ( scroll_to ) {
			$( 'html, body' ).animate({
				scrollTop: $title_bar.find( '.notices' ).offset().top - $( '#header' ).outerHeight() - 25
			}, anim_speed );
		}
	};

	let _show_notice = function( id, message, type, clear_after ) {
		let $notices_wrapper = $title_bar.find( '.notices' );

		$notices_wrapper.append( '<div id="notice-' + id + '" style="display:none;" class="crate-notice notice ' + type + '">' + message + '</div>' ).append( () => {
			let $notice = $notices_wrapper.find( '#notice-' + id );

			$notice.slideDown( anim_speed );

			if ( clear_after ) {

				setTimeout( () => {
					$notice.slideUp( anim_speed );

					setTimeout( () => {
						$notice.remove();
					}, anim_speed );

				}, notice_show_time );
			}
		} );
	};

	let clear_notices = function () {
		let $notices_wrapper = $title_bar.find( '.notices' );

		$notices_wrapper.find( '.notice' ).slideUp( anim_speed );

		setTimeout( () => {
			$notices_wrapper.find( '.notice' ).remove();
		}, anim_speed );
	};

	$( document ).ready( _init );

	return {
		clear_notices: clear_notices
	}

} ( jQuery );

module.exports = event_single_add_to_basket;